export default `
fragment ParagraphVideoNetshow on ParagraphVideoNetshow {
  id
  uuid
  entityBundle
  title
  description {
    value
  }
  netshow_urls
}
`
